import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { selectLoaded, selectLoading, selectSaving, selectSaved, selectError, selectQuizQuestion, selectCreatedId } from '../selectors/quiz-question.selector';
import { quizQuestionActions } from '../actions/quiz-question.actions';
import { QuizQuestionValue } from '../models';

@Injectable({
    providedIn: 'root',
})
export class QuizQuestionFacade {
    private store = inject(Store);

    readonly loaded$ = (id: string) => this.store.select(selectLoaded(id));
    readonly loadedNonNullable$ = (id: string) => this.store.select(selectLoaded(id)).pipe(filter((loaded) => loaded !== null));
    readonly loading$ = (id: string) => this.store.select(selectLoading(id));
    readonly saving$ = this.store.select(selectSaving);
    readonly saved$ = this.store.select(selectSaved);
    readonly quizQuestion$ = (id: string) => this.store.select(selectQuizQuestion(id));
    readonly quizQuestionNonNullable$ = (id: string) => this.store.select(selectQuizQuestion(id)).pipe(filter((quizQuestion) => quizQuestion !== null));

    readonly quizQuestion = (id: string) => this.store.selectSignal(selectQuizQuestion(id));
    readonly loading = (id: string) => this.store.selectSignal(selectLoading(id));
    readonly saving = this.store.selectSignal(selectSaving);
    readonly saved = this.store.selectSignal(selectSaved);
    readonly error = (id: string) => this.store.selectSignal(selectError(id));
    readonly createdId = this.store.selectSignal(selectCreatedId);

    getQuizQuestion(id: string): void {
        this.store.dispatch(quizQuestionActions.getQuizQuestion({ id }));
    }

    createQuizQuestion(value: QuizQuestionValue): void {
        this.store.dispatch(quizQuestionActions.createQuizQuestion({ value }));
    }

    updateQuizQuestion(id: string, value: QuizQuestionValue): void {
        this.store.dispatch(quizQuestionActions.updateQuizQuestion({ id, value }));
    }

    deleteQuizQuestion(id: string): void {
        this.store.dispatch(quizQuestionActions.deleteQuizQuestion({ id }));
    }

    clear(): void {
        this.store.dispatch(quizQuestionActions.clear());
    }
}
